
import React, { useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const MeineVision = () => {
  const videoUrl = "https://www.youtube.com/embed/vPKQdQRa6Jw";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNavigateBack = () => {
    const section = document.getElementById('ns3');
    if (section) {
      const offset = -80;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <div className="bg-gradient-to-r from-[#243949] to-[#517fa4]" id="vision">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4" />
              <ChevronLeft className="w-4 h-4 -ml-2" />
            </div>
          </Button>
          
          <h2 className="text-xl md:text-2xl text-white font-bold text-center uppercase flex-grow">
            Meine Vision...
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Image section now with constraints to match NS2-4 */}
          <div className="flex flex-col items-center">
            <div className="w-full max-w-xl mb-8">
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <div className="relative aspect-[16/9] w-full bg-white rounded-lg overflow-hidden">
                  <div className="absolute inset-0 p-4 md:p-8 flex items-center justify-center">
                    <div className="absolute inset-0">
                      {/* Größere stilisierte Noten als Hintergrundelemente */}
                      <div className="absolute top-2 left-4 text-4xl md:text-5xl opacity-10">♪</div>
                      <div className="absolute top-4 right-8 text-4xl md:text-5xl opacity-10">♫</div>
                      <div className="absolute bottom-4 left-8 text-4xl md:text-5xl opacity-10">♩</div>
                      <div className="absolute bottom-2 right-4 text-4xl md:text-5xl opacity-10">♪</div>
                    </div>
                    <p className="text-center font-['Dancing_Script'] text-lg md:text-3xl leading-relaxed text-black relative z-10 px-4">
                      "Ich wünsche dir, dass der Weg, den du gehst<br/>
                      Auch wenn dir niemand folgt, er für dich der Richtige ist -<br/>
                      ich wünsche dir ein großes Leben"
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h3 className="text-base md:text-lg text-white font-bold text-center uppercase mb-8">
            ...oder warum diese Seite "Ein grosses Leben" heisst
          </h3>

          {/* First text box - Updated styling to match NS3 */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Als ich Pfarrer war, habe ich meinen Konfirmanden am Abend vor der Konfirmation in einem besonderen Gottesdienst mit einer Band unterstützt das Lied "<strong>Ein großes Leben</strong>" zugesungen.
            </p>
          </div>

          {/* Second text box - Updated styling to match NS3 */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Ich wollte Ihnen mitgeben: "Jeder von euch hat tolle, einzigartige Gaben geschenkt bekommen. Und vor euch liegt ein großes Leben. Entdeckt, wofür euer Herz schlägt und hört auf eure Leidenschaften. Und folgt ihnen. Lasst euch nicht beirren, wenn eure Eltern oder Lehrer oder sonst wer euch sagt "Ihr könnt das nicht!" Nein, ihr könnt ganz viel! <strong>Vor euch liegt ein großes Leben!</strong>"
            </p>
          </div>

          {/* Third text box - Updated styling to match NS3 */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-8">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Und das ist tatsächlich meine Überzeugung. Auch heute noch. Und deshalb mache ich dieses Coaching...
            </p>
          </div>

          <div className="mt-12">
            {/* Video section now medium-sized with title inside the box */}
            <div className="flex flex-col items-center">
              <div className="w-full max-w-sm">
                <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                  <h3 className="text-base font-bold mb-3 text-white text-center uppercase">
                    UNHEILIG - "EIN GROßES LEBEN"
                  </h3>
                  <AspectRatio ratio={16/9}>
                    <iframe
                      className="w-full h-full rounded-lg shadow-lg border-2 border-white/40"
                      src={videoUrl}
                      title="Unheilig - Ein großes Leben"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </AspectRatio>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-8">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-white/10 p-2 h-auto group"
              onClick={handleNavigateBack}
            >
              <div className="flex items-center animate-horizontal-bounce">
                <ChevronLeft className="w-4 h-4" />
                <ChevronLeft className="w-4 h-4 -ml-2" />
              </div>
              <span className="ml-2">Zurück</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeineVision;
